import { useDispatch } from 'react-redux';

import { RetrieveAccountsInputDto, RetrieveAccountsOutputDto } from '@api/ecommerce-xp';
import { useAutoFetch } from '@hooks';
import { saveSuccessServiceResponse } from '@store';

export const useFetchRetrieveAccounts = () => {
	const dispatch = useDispatch();

	return useAutoFetch<RetrieveAccountsInputDto, RetrieveAccountsOutputDto>({
		data: {},
		operationKey: 'retrieveAccounts',
		withLoading: false,
		cache: {
			key: 'retrieveAccounts',
		},
		onSuccess: (res) => {
			res && dispatch(saveSuccessServiceResponse({ retrieveAccounts: res.data }));
		},
	});
};
